import React, { useState, useEffect, useContext } from 'react';
import { FaKey } from 'react-icons/fa';
import Layout from '../components/Layout';
import WhiteCard from '../components/WhiteCard';
import AppContext from '../api/AppContext';
import axios from 'axios';

function Colaboradores() {
  const { token } = useContext(AppContext);
  const APP_URL = 'https://app.olympicbarbacena.com.br';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: 'staff',
    password: '',
    passwordConfirm: ''
  });
  const [colaboradores, setColaboradores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Detecta mudança no tamanho da tela
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Carrega colaboradores ao montar o componente
  useEffect(() => {
    fetchColaboradores();
  }, []);

  const fetchColaboradores = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${APP_URL}/api/admin/users`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      setColaboradores(response.data.data.users);//.filter(user => user.role !== 'member')
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Erro ao carregar colaboradores');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.passwordConfirm) {
      setError('As senhas não coincidem');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${APP_URL}/api/auth/signup`, {
        ...formData,
        role: formData.role
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      setFormData({
        name: '',
        email: '',
        role: 'staff',
        password: '',
        passwordConfirm: ''
      });
      setError(null);
      fetchColaboradores(); // Recarrega a lista
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao criar colaborador');
    } finally {
      setLoading(false);
    }
  };

  const updateRole = async (userId, newRole) => {
    try {
      await axios.patch(`${APP_URL}/api/admin/users/${userId}`, {
        role: newRole
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      fetchColaboradores(); // Atualiza a lista
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao atualizar permissão');
    }
  };

  const deleteColaborador = async (userId) => {
    try {
      await axios.delete(`${APP_URL}/api/admin/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      fetchColaboradores(); // Atualiza a lista
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao excluir colaborador');
    }
  };

  return (
    <Layout title="Colaboradores" icon={FaKey}>
      <div style={isMobile ? styles.mobileContainer : styles.desktopContainer}>
        <div style={styles.innerContainer}>
          <WhiteCard style={styles.cardForm}>
            <form style={styles.form} onSubmit={handleSubmit}>
              <label htmlFor="name" style={styles.label}>Nome completo:</label>
              <input
                id="name"
                name="name"
                style={styles.input}
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label htmlFor="email" style={styles.label}>E-mail:</label>
              <input
                id="email"
                name="email"
                style={styles.input}
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="role" style={styles.label}>Permissão:</label>
              <select
                id="role"
                name="role"
                style={styles.select}
                value={formData.role}
                onChange={handleChange}
                required
              >
                <option value="admin">Secretaria</option>
                <option value="staff">Lanchonete</option>
                <option value="member">Associado</option>
              </select>

              <label htmlFor="password" style={styles.label}>Senha:</label>
              <input
                id="password"
                name="password"
                style={styles.input}
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength="8"
              />

              <label htmlFor="passwordConfirm" style={styles.label}>Confirmar senha:</label>
              <input
                id="passwordConfirm"
                name="passwordConfirm"
                style={styles.input}
                type="password"
                value={formData.passwordConfirm}
                onChange={handleChange}
                required
                minLength="8"
              />
              
              {error && <p style={styles.error}>{error}</p>}
              
              <button type="submit" style={styles.button} disabled={loading}>
                {loading ? 'Processando...' : '+ Adicionar colaborador'}
              </button>
            </form>
          </WhiteCard>

          {/* Lista de colaboradores */}
          <div style={styles.listContainer}>
            {loading && colaboradores.length === 0 ? (
              <p style={styles.loadingText}>Carregando...</p>
            ) : (
              colaboradores.map((colab) => (
                <WhiteCard key={colab._id} style={styles.colaboradorCard}>
                  <div style={isMobile ? styles.colaboradorItemMobile : styles.colaboradorItemDesktop}>
                    <div style={styles.colaboradorInfo}>
                      <span style={styles.nome}>{colab.name}</span>
                      <span style={styles.email}>{colab.email}</span>
                    </div>
                    
                    <div style={styles.actionsContainer}>
                      <select
                        style={isMobile ? styles.selectPermissaoMobile : styles.selectPermissaoDesktop}
                        value={colab.role}
                        onChange={(e) => updateRole(colab._id, e.target.value)}
                      >
                        <option value="admin">Administrador</option>
                        <option value="staff">Lanchonete</option>
                        <option value="member">Associado</option>
                      </select>

                      <button
                        style={isMobile ? styles.excluirMobile : styles.excluirDesktop}
                        onClick={() => deleteColaborador(colab._id)}
                        title="Excluir colaborador"
                      >
                        {isMobile ? '🗑️' : 'Excluir'}
                      </button>
                    </div>
                  </div>
                </WhiteCard>
              ))
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

const styles = {
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
    maxWidth: '1200px',
    margin: '0 auto',
  },

  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '25px',
    maxWidth: '800px',
    margin: '0 auto'
  },

  cardForm: {
    width: '100%',
    padding: '20px',
    boxSizing: 'border-box'
  },
  
  form: {
    width: '100%',
  },
  
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '500',
    fontSize: '14px',
    color: '#333',
  },
  
  input: {
    width: '100%',
    padding: '12px 15px',
    marginBottom: '15px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '16px',
    boxSizing: 'border-box',
    backgroundColor: '#f9f9f9'
  },
  
  select: {
    width: '100%',
    padding: '12px 15px',
    marginBottom: '15px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9'
  },
  
  button: {
    width: '100%',
    padding: '15px',
    fontSize: '16px',
    fontWeight: '600',
    fontFamily: 'Montserrat, sans-serif',
    color: '#fff',
    backgroundColor: 'rgb(9, 68, 140)',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  
  listContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  
  loadingText: {
    textAlign: 'center',
    padding: '20px',
    color: '#666',
  },
  
  colaboradorCard: {
    padding: '20px',
  },
  
  colaboradorItemDesktop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '15px',
    width: '100%',
  },
  
  colaboradorItemMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
  },
  
  colaboradorInfo: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
  
  nome: {
    fontWeight: '600',
    fontSize: '16px',
    marginBottom: '4px',
    color: '#333',
  },
  
  email: {
    fontSize: '14px',
    color: '#666',
  },
  
  actionsContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  
  selectPermissaoDesktop: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    cursor: 'pointer',
    minWidth: '140px',
    backgroundColor: '#f9f9f9',
  },
  
  selectPermissaoMobile: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9',
  },
  
  excluirDesktop: {
    backgroundColor: '#ff4d4f',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  
  excluirMobile: {
    backgroundColor: '#ff4d4f',
    border: 'none',
    color: 'white',
    padding: '10px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    minWidth: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  error: {
    color: '#ff4d4f',
    fontSize: '14px',
    marginBottom: '15px',
    textAlign: 'center',
    padding: '10px',
    backgroundColor: '#fff2f0',
    borderRadius: '6px',
    border: '1px solid #ffccc7',
  }
};

// Adicionando hover effects para desktop
if (typeof window !== 'undefined' && window.innerWidth >= 768) {
  styles.button[':hover'] = {
    backgroundColor: 'rgb(7, 55, 115)',
  };
  
  styles.excluirDesktop[':hover'] = {
    backgroundColor: '#d9363e',
  };
}

export default Colaboradores;